<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
  >
    <path
      d="M11.4398 21.1198C6.0873 21.1198 1.75977 16.7922 1.75977 11.4398C1.75977 6.0873 6.0873 1.75977 11.4398 1.75977C16.7922 1.75977 21.1198 6.0873 21.1198 11.4398C21.1198 16.7922 16.7922 21.1198 11.4398 21.1198ZM11.4398 2.89859C6.71365 2.89859 2.89859 6.71365 2.89859 11.4398C2.89859 16.1659 6.71365 19.9809 11.4398 19.9809C16.1659 19.9809 19.9809 16.1659 19.9809 11.4398C19.9809 6.71365 16.1659 2.89859 11.4398 2.89859Z"
      fill="#5E6A79"
    />
    <path
      d="M8.7998 15.3383V7.17188L15.8398 11.2551L8.7998 15.3383ZM9.73847 8.76761V13.6956L13.9625 11.2081L9.73847 8.76761Z"
      fill="#5E6A79"
    />
  </svg>
</template>

<script>
export default {name:'GreyPlayIcon'};
</script>

<style></style>
